import { generateKeyString } from "#src/utils/common";
import type { InternalToastProps, WrittenOnTheToast } from "./core/types";
import { ToastSlice } from "./ToastSlice";
import { useToastList } from "./core/useToastList";
import { Observable } from "#src/utils/observer";

const toastObservable = new Observable();

/** Where we store the newly cooked toasts. When a toast is created, it will appear here. */
const Toaster = () => {
  const toasts = useToastList(toastObservable);

  return (
    <div className="flex flex-col">
      {toasts.map((toast) => (
        <ToastSlice
          key={`toast-${toast.id}`}
          toast={toast}
          observable={toastObservable}
        />
      ))}
    </div>
  );
};

const createToast = (newToast: WrittenOnTheToast) => {
  const internalToast: InternalToastProps = {
    ...newToast,
    id: generateKeyString(),
    status: "stable",
  };
  toastObservable.notify(internalToast);
};

export { Toaster, createToast };
